import {
  FAILED_GET_QUOTE,
  FAILED_GET_QUOTES,
  FAILED_PERSIST_QUOTE,
  RECEIVE_GET_NOTIFICATION_TEMPLATE,
  RECEIVE_GET_QUOTE,
  RECEIVE_GET_QUOTES,
  RECEIVE_PERSIST_QUOTE,
  REQUEST_PERSIST_QUOTE,
  RECEIVE_MESSAGES_SUCCESS,
} from 'redux/actions/quote'
import { RESET_STATE } from 'redux/actions/global'

const initialState = {
  form: {
    data: null,
    error: '',
    fetching: true,
    sending: false,
    deleting: false,
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0,
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_QUOTE:
    case FAILED_PERSIST_QUOTE:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        },
      }
    case RECEIVE_PERSIST_QUOTE:
    case RECEIVE_GET_QUOTE:
      return {
        ...state,
        form: {
          data: action.data,
          fetching: false,
          sending: false,
        },
      }
    case RECEIVE_GET_QUOTES:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        },
      }
    case REQUEST_PERSIST_QUOTE:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true,
        },
      }
    case RECEIVE_GET_NOTIFICATION_TEMPLATE:
      return {
        ...state,
        form: {
          ...state.form,
          notificationTemplate: action.data,
        },
      }
    case RESET_STATE:
      if (action.state === 'quote') {
        return {
          ...state,
          [action.screen]: initialState[action.screen],
        }
      }
    default:
      return state
  }
}
